export default "/images/MarionLorenzi.jpg?f03c073b22da5dad6dcb6a7de926f552";